import {
  Abnormal,
  AcceptEmail,
  Add,
  AddOne,
  AddSubset,
  Agreement,
  AirConditioning,
  AlignBottomTwo,
  Analysis,
  Appointment,
  ArrowRight,
  Back,
  BatteryWorkingOne,
  BookOne,
  BookmarkOne,
  Bug,
  CalendarThirtyTwo,
  ChartProportion,
  Check,
  CheckCorrect,
  CheckOne,
  Checklist,
  CircleDoubleLeft,
  CircleDoubleRight,
  Clear,
  ClearFormat,
  Clipboard,
  CloseOne,
  Comment,
  Computer,
  ConnectionPoint,
  Copy,
  DataUser,
  DateComesBack,
  Delete,
  DeleteThemes,
  DeleteTwo,
  Devices,
  DifferenceSet,
  DocDetail,
  DocSuccess,
  DoubleLeft,
  DoubleRight,
  DownloadThree,
  Edit,
  EditOne,
  EditTwo,
  Editor,
  ElectronicDoorLock,
  EmailFail,
  EmailSuccessfully,
  Equalizer,
  FigmaResetInstance,
  FileAddition,
  FileCabinet,
  FileConversionOne,
  FileDateOne,
  FileFailedOne,
  FileSuccessOne,
  Filter,
  FinancingTwo,
  FolderConversion,
  FolderMinus,
  FolderSuccess,
  FolderWithdrawal,
  Forbid,
  GreatWall,
  HandleRight,
  HandleTriangle,
  HandleX,
  Hands,
  Help,
  History,
  IdCardH,
  InboxSuccess,
  Info,
  Inspection,
  Ipad,
  Laptop,
  List,
  ListCheckbox,
  ListTwo,
  ListView,
  Lock,
  Login,
  Logout,
  Mail,
  MailOpen,
  MailReview,
  MallBag,
  MassageChairOne,
  MassageTable,
  Me,
  MessageFailed,
  MessageSuccess,
  MicroscopeOne,
  MicrowaveOven,
  MonitorOne,
  Moon,
  MoreApp,
  NintendoSwitch,
  NoShooting,
  Optional,
  PageTemplate,
  ParagraphBreakTwo,
  PauseOne,
  People,
  PeopleLeft,
  PeopleRight,
  Permissions,
  PhoneVideoCall,
  PieTwo,
  Plan,
  Play,
  PlayCycle,
  PlaybackProgress,
  Power,
  PreviewClose,
  PreviewOpen,
  PrinterOne,
  ProjectorTwo,
  Refrigerator,
  RightUser,
  RobotOne,
  Router,
  Save,
  Sd,
  Seal,
  Search,
  Send,
  SendEmail,
  Server,
  ShareTwo,
  Shopping,
  ShoppingCart,
  ShoppingCartAdd,
  ShoppingCartDel,
  ShoppingCartOne,
  Sofa,
  Success,
  SunOne,
  Switch,
  Time,
  TimedMail,
  Tool,
  Transaction,
  TransactionOrder,
  Treadmill,
  TurnAround,
  TvOne,
  Undo,
  UploadThree,
  User,
  UserBusiness,
  ViewGridDetail,
  ViewGridList,
  Voice,
  Warehousing,
  Wifi,
  WindmillTwo,
  WrongUser
} from '@icon-park/vue/es/map'
import svgLinkTopRight from './svg-link-top-right'
const IconMap = [
  svgLinkTopRight,
  WindmillTwo,
  CloseOne,
  AddSubset,
  ShareTwo,
  ViewGridDetail,
  Permissions,
  ShoppingCartDel,
  Success,
  Seal,
  RobotOne,
  People,
  Me,
  DocSuccess,
  Undo,
  FolderWithdrawal,
  Ipad,
  MassageTable,
  MonitorOne,
  Clear,
  Sofa,
  MoreApp,
  FileCabinet,
  BatteryWorkingOne,
  PrinterOne,
  Laptop,
  GreatWall,
  PhoneVideoCall,
  Wifi,
  Delete,
  Filter,
  Search,
  ClearFormat,
  Clipboard,
  FigmaResetInstance,
  ElectronicDoorLock,
  FileAddition,
  PeopleLeft,
  PeopleRight,
  NoShooting,
  Tool,
  Appointment,
  Power,
  CheckCorrect,
  HandleTriangle,
  ListTwo,
  Me,
  Save,
  Editor,
  Back,
  Add,
  CheckOne,
  TurnAround,
  BookOne,
  DeleteTwo,
  Comment,
  MessageFailed,
  MessageSuccess,
  DataUser,
  SunOne,
  Moon,
  Login,
  User,
  ConnectionPoint,
  PlayCycle,
  DateComesBack,
  UserBusiness,
  RightUser,
  WrongUser,
  Devices,
  Computer,
  Logout,
  EditOne,
  DocDetail,
  IdCardH,
  ShoppingCartAdd,
  DeleteThemes,
  Hands,
  CircleDoubleRight,
  CircleDoubleLeft,
  Shopping,
  ShoppingCart,
  TransactionOrder,
  ShoppingCartOne,
  InboxSuccess,
  MallBag,
  DocDetail,
  IdCardH,
  ShoppingCartAdd,
  DeleteThemes,
  InboxSuccess,
  FolderConversion,
  Equalizer,
  Transaction,
  FileDateOne,
  FileFailedOne,
  FileSuccessOne,
  FileConversionOne,
  Agreement,
  BookmarkOne,
  MailReview,
  EmailFail,
  TimedMail,
  FolderSuccess,
  EmailSuccessfully,
  FolderMinus,
  ProjectorTwo,
  Voice,
  Router,
  NintendoSwitch,
  Server,
  TvOne,
  MicrowaveOven,
  Refrigerator,
  AirConditioning,
  Sd,
  MassageChairOne,
  FinancingTwo,
  ViewGridList,
  Play,
  PauseOne,
  HandleX,
  Warehousing,
  AddOne,
  PlaybackProgress,
  Info,
  EditTwo,
  Copy,
  Abnormal,
  PreviewOpen,
  Mail,
  MailOpen,
  Treadmill,
  Check,
  History,
  DownloadThree,
  UploadThree,
  DocSuccess,
  Analysis,
  Checklist,
  Plan,
  Inspection,
  Checklist,
  HandleRight,
  PrinterOne,
  Optional,
  DifferenceSet,
  List,
  ListCheckbox,
  Forbid,
  Edit,
  AlignBottomTwo,
  ListView,
  Help,
  SendEmail,
  Switch,
  CalendarThirtyTwo,
  ArrowRight,
  DoubleLeft,
  DoubleRight,
  PreviewClose,
  Bug,
  PageTemplate,
  Time,
  MicroscopeOne,
  ParagraphBreakTwo,
  AcceptEmail,
  Send,
  ChartProportion,
  PieTwo,
  Lock
]

const SVG_CONFIG = Object.freeze({
  prefix: 't-svg'
})

/**
 * register iconPark Components
 * @param {Vue} Vue Vue
 */
export default function installSvgIcon(Vue) {
  IconMap.forEach(function (icon) {
    Vue.component(SVG_CONFIG.prefix ? SVG_CONFIG.prefix + '-' + icon.name.slice(5) : icon.name, icon)
  })
}
